module.exports = __webpack_public_path__ + "img/caving.8f22b5d5.svg";